export default {"src":"/_next/static/media/apprentissage.6e29c215.svg","height":417,"width":744};